import { ReactNode } from 'react';
import './css/Skeleton.css';

type DivProps = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>;

export function SkeletonTitle() {
  return <div className="skeleton skeleton-title"></div>;
}

export function SkeletonText() {
  return <div className="skeleton skeleton-text"></div>;
}

export function Skeleton({ className, ...props }: DivProps) {
  return <div className={`skeleton ${className}`} {...props}></div>;
}

type WithSkeletonProps = {
  isLoading: boolean;
  children: ReactNode;
  skeleton?: ReactNode;
};

export function WithSkeleton({
  isLoading,
  children,
  skeleton,
}: WithSkeletonProps) {
  return <>{isLoading ? skeleton : children}</>;
}
